import React from "react";


export default function Title ({product}){
    const title=()=>{
        if(!product.title && product.platform_id===4 ){
            return product.prod_link.split('/')[3]?.replaceAll("-"," ");
        }else{
            return product.title || "";
        }
    }
    return (
        <p>
            {title()}
        </p>
    )

}